import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { DashboardCircleService } from '../../../../shared/services/dashboard-circle-service/dashboard-circle-service';
import { HeaderService } from '../../../../shared/services/list-services/header.service';
import { RollupGroupingFooterService } from '../../../../shared/services/rollup-grouping-footer-service/rollup-grouping-footer-service';
import { NvMatTooltipModule } from '../../nv-mat-tooltip/nv-mat-tooltip.module';
import { RollupTableComponent } from './rollup-table.component';

@NgModule({
  imports: [CommonModule, CdkTableModule, NvMatTooltipModule],
  declarations: [RollupTableComponent],
  exports: [RollupTableComponent],
  providers: [RollupGroupingFooterService, DashboardCircleService, HeaderService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class RollupTableModule {
  /** */
}
